import { BaseIRemoteBloc } from "./bloc.base"

export class CloudIRemoteBloc extends BaseIRemoteBloc {

}

